export type MobilePlatform = 'ios' | 'android' | 'desktop';

export function detectMobilePlatform(): MobilePlatform {
  if (typeof navigator === 'undefined') {
    return 'desktop';
  }

  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) {
    return 'android';
  }
  if (/iPad|iPhone|iPod/i.test(ua)) {
    return 'ios';
  }
  return 'desktop';
}

export function isMobileDevice(): boolean {
  const platform = detectMobilePlatform();
  return platform === 'ios' || platform === 'android';
}
